<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/notFound
</style>

<template>
    <Zone
        :id="$json.notfound.id"
        :dataLabel="$json.notfound.dataLabel"
        :contrast="contrast"
        class="g_error404"
        autoHeight>
        <Heading
            :level="2"
            v-html="$json.notfound.title" />
        <Paragraph :content="$json.notfound.content" size="L" />
    </Zone>
</template>

<script>
export default {
    name: 'NotFound',
    props: {
        contrast: {
            type: String,
            default: 'light'
        }
    },
    methods: {
        pageIs (page) {
            return this.$landing.project === page
        }
    }
}
</script>
